import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { News, NewsDTO } from '@common/models/news';

@Injectable({ providedIn: 'root' })
export class NewsService {

  private readonly _baseUrl = `${environment.commonApiUrl}/api/news`;

  constructor(private _http: HttpClient) {}

  /** Devuelve todas las noticias y campañas */
  findAll(): Observable<News[]> {
    return this._http.get<News[]>(this._baseUrl);
  }

  /** Devuelve las noticias/campañas por su tipo ('news' | 'campaigns') */
  findByType(type: string): Observable<News[]> {
    return this._http.get<News[]>(`${this._baseUrl}/type/${type}`);
  }

  /** Devuelve una noticia/campaña por su id */
  findById(id: string): Observable<News> {
    return this._http.get<News>(`${this._baseUrl}/${id}`);
  }

  /** Crea una noticia/campaña */
  create(dto: NewsDTO): Observable<any> {
    return this._http.post<any>(this._baseUrl, dto);
  }

  /** Edita una noticia/campaña */
  update(id: string, dto: NewsDTO): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${id}`, dto);
  }

  /** Elimina una noticia/campaña */
  delete(id: string): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${id}`);
  }
}
